module.exports = __webpack_public_path__ + "img/bottom_xcx.a821ee6a.png";